// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__SbxK7","btn":"styles_btn__t9fgk","btnTxt":"styles_btnTxt__siZ1D"};